// extracted by mini-css-extract-plugin
module.exports = {"root":"Form_root__1vJlK","inner":"Form_inner__1cn6v","range":"Form_range__1eBKl","name":"Form_name__3C3d2","actions":"Form_actions__34Kdp"};